import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

const AuthCallback = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const handleRedirect = async () => {
      await instance.handleRedirectPromise();
      navigate("/", { replace: true });
    };

    handleRedirect();
  }, [instance, navigate]);

  return null;
};

export default AuthCallback;
